import UXEvents from '@enums/ux-events';

export default [
    {
        key: UXEvents.variableFundingUpdated,
        actions: ['variableFundingAgreements/submitVariableFunding'],
    },
];
